import axios from 'axios';
import { store } from '~redux_related/store';

export const newsAPI = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};

export const newsAPIMultipart = function () {
    const token = store.getState().user.newsUser.token;
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            Authorization: 'Token ' + token,
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'content-type': 'multipart/form-data',
        },
    };
    return axios.create(params);
};

export const newsAPILite = function () {
    const params = {
        baseURL: process.env.NEWS_API_URL,
        headers: {
            frontendkey: 'Pu98ZrvShCrcqAuU',
            'Content-Type': 'application/json',
        },
    };
    return axios.create(params);
};



// WEBPACK FOOTER //
// ./src/api/news.js